module.exports = __webpack_public_path__ + "static/media/java.564b664c.png";